<h2>
    Login is required to access this area
</h2>
<div>
    <button type="button" class="btn btn-primary" (click)="clickLogin()">Login</button>
    <button type="button" class="btn btn-default" (click)="clickBack()">Back</button>
    <button type="button" class="btn btn-default" (click)="clickLogout()">Logout</button>
</div>